import { StyledCheckbox } from '../PointsOfInterest/SummaryCard/styles';
import { ActionHeaderContainer } from './styles';
import { FormControlLabel, Stack, Typography } from '@mui/material';
import { BulkReviewAction } from './BulkReviewAction';
import { useAtom, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useFeatureFlag } from '@/hooks';
import { FieldSelector } from './FieldSelector';

export const ActionHeader = ({
  variant = 'default',
  poiType,
  templateId,
  location = 'review-panel',
  leftContent,
}: {
  variant?: 'default' | 'compact';
  poiType?: string;
  templateId?: string;
  location?: string;
  leftContent?: React.ReactNode;
}) => {
  const [isAllReviewPointsOfInterestSelected, setIsAllReviewPointsOfInterestSelected] = useAtom(
    state.isAllReviewPointsOfInterestSelected
  );
  const setSelectedReviewPointsOfInterest = useSetAtom(state.selectedReviewPointsOfInterest);
  const handleSelectAllChange = (
    _event: React.SyntheticEvent<Element, Event>,
    checked: boolean
  ) => {
    setIsAllReviewPointsOfInterestSelected(checked);
    setSelectedReviewPointsOfInterest([]);
  };

  const canViewReviewScreen = useFeatureFlag(['api-inspector', 'mi-engineer']);

  const actionContent = (
    <>
      {variant === 'default' && canViewReviewScreen && (
        <FormControlLabel
          sx={{
            gap: '1.2rem',
            margin: 0,
          }}
          checked={isAllReviewPointsOfInterestSelected}
          control={<StyledCheckbox disableRipple />}
          label={
            <Typography variant="caption" fontWeight={600} color="primary.500">
              Select all
            </Typography>
          }
          onChange={handleSelectAllChange}
        />
      )}
      {canViewReviewScreen && (
        <BulkReviewAction
          variant={variant}
          poiType={poiType}
          templateId={templateId}
          className={`${location}-bulk-review-action`}
        />
      )}
      {!canViewReviewScreen && (
        <FieldSelector
          variant={variant}
          poiType={poiType}
          className={`${location}-field-selector`}
        />
      )}
    </>
  );

  return (
    <ActionHeaderContainer
      variant={variant}
      sx={leftContent ? { justifyContent: 'flex-end' } : undefined}
    >
      {leftContent ? (
        <Stack direction="row" alignItems="center" gap={1.2}>
          {leftContent}
          {actionContent}
        </Stack>
      ) : (
        actionContent
      )}
    </ActionHeaderContainer>
  );
};
